import { Component, ViewEncapsulation } from '@angular/core'; 
import { FnGridAbstractCell } from '../../model/fn-grid-abstract-cell.model';

@Component({
	selector: 'fn-grid-currency',
	templateUrl: 'fn-grid-currency.component.html',
	styleUrls: ['fn-grid-currency.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class FnGridCurrencyComponent extends FnGridAbstractCell {}
